import { PaziaSelect } from "../PaziaSelect/PaziaSelect";

export const HEADING_TAG_OPTIONS = [
  { value: "h1", label: "H1" },
  { value: "h2", label: "H2" },
  { value: "h3", label: "H3" },
  { value: "h4", label: "H4" },
  { value: "h5", label: "H5" },
  { value: "span", label: "Span" },
  { value: "p", label: "Paragraph" },
];

interface HeadingTagSelectProps {
  name: string;
  label?: string;
}

export function HeadingTagSelect({ name, label = "Tag nagłówka" }: HeadingTagSelectProps) {
  return (
    <PaziaSelect
      name={name}
      label={label}
      options={HEADING_TAG_OPTIONS}
    />
  );
}
